<template>
    <div>
        <div class="splide" id="campaign-pictures" v-if="imageList.length > 1" data-cy="container_campaign_picture_slider_multiple">
            <div class="splide__track" data-cy="container_campaign_slider_track">
                <ul class="splide__list" data-cy="list_campaign_slider_images">
                    <li class="splide__slide"
                        v-for="(image, k) in imageList"
                        :key="k"
                        :data-cy="`card_campaign_image_${k}`">
                        <img class="w-full rounded-lg shadow-md" data-cy="img_campaign_image" :src="image.fullImageUrl">
                    </li>
                </ul>
            </div>
        </div>
        <div v-else data-cy="container_campaign_picture_single">
            <img class="w-full rounded-lg shadow-md" data-cy="img_campaign_image_single" :src="imageList[0].fullImageUrl">
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/

export default {
    name: "Picture",
    props: {
        campaign: { type: Object, required: true },
    },
    data: function() {
        return {
            imageList: this.campaign.pictures,
        };
    },
    mounted: function() {
        if (this.imageList.length > 1) {
            new Splide('#campaign-pictures', {
                type: 'loop',
                arrows: false,
            }).mount();
        }
    },
}
</script>
<style lang="scss" scoped>

</style>
